module.exports = __webpack_public_path__ + "img/banner-1.3fa77950.jpg";